/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowDancePartyTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowDanceParty,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Dance the Night Away!",
    "Get Ready to Groove!",
    "Dance Party Awaits!",
  ],
  title: "Dance Party",
  description: "Organize a lively dance party.",
  longDescription:
    "Gather your friends for an energetic dance party! Choose a date, plan the playlist, and decide on refreshments to keep the energy up!",
  emoji: "💃",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Dance Party",
          emoji: "💃",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the dance party?",
          emoji: "📅",
          completeAction: {
            question: "Decide on the playlist?",
            description:
              "What songs should we include in our dance party playlist?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What songs should we add?",
                emoji: "🎶",
                completeAction: {
                  question: "Decide on refreshments?",
                  description: "What snacks and drinks should we serve?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we bring?",
                      emoji: "🍿",
                    },
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What drinks should we serve?",
                      emoji: "🥤",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Get Ready to Dance!",
    outroDescription:
      "Your dance party plans are set! Enjoy the rhythm and fun!",
  },
};
